import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { withSpinner } from "../../extensions/withSpinner.extension";
import { API_ROOT } from "../../types/constants/appconstants";
import { OverdueTaskDetailReportParameters } from "../../types/overduetaskdetailreportparameters";
import { ConstructionDeliveryReportParams, Lot, UpdatedSchedulesReportParam, Vendor, WeeklyReportParams } from './../../types';

@Injectable({
    "providedIn": "root"
})
export class ReportService {
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private reportBaseUrl = this.apiRoot + "api/reports";

    downloadConstructionDeliveryReport(constructionDeliveryReportParams: ConstructionDeliveryReportParams): Observable<Blob> {
        return withSpinner(this.http).post(`${this.reportBaseUrl}/downloadconstructiondeliveryreport`, constructionDeliveryReportParams, { responseType: "blob" });
    }

    downloadFile(tradePartners: Vendor[], lots: Lot[], reportTypes: string[], taskStatus: string, includeInternalTasks: boolean, includeScarTasks: boolean, format: string): Observable<Blob> {
        return withSpinner(this.http).post(`${this.reportBaseUrl}/downloadfile`, {
            "tradePartners": tradePartners,
            "lots": lots, "reportTypes": reportTypes, "taskStatus": taskStatus, "includeInternalTasks": includeInternalTasks, "includeScarTasks": includeScarTasks, "format": format
        }, { responseType: "blob" });
    }

    downloadSchedulePermitsReport(communityIds: number[], lotStatus: string, format: string): Observable<Blob> {
        return withSpinner(this.http).post(`${this.reportBaseUrl}/downloadpermitsreport`, {
            "communityIds": communityIds, "lotStatus": lotStatus, "format": format
        }, { responseType: "blob" });
    }

    downloadOverdueTaskDetailReport(reportParameters: OverdueTaskDetailReportParameters): Observable<Blob>{
        return withSpinner(this.http).post(`${this.reportBaseUrl}/downloadoverduetaskdetailreport`, reportParameters , { responseType: "blob" });
    }

    downloadWeeklyReport(weeklyReportParams: WeeklyReportParams): Observable<Blob> {        
        return withSpinner(this.http).post(`${this.reportBaseUrl}/downloadweeklyreport`, weeklyReportParams, { responseType: "blob" });
    }

    downloadUpdatedSchedulesReport(updatedSchedulesReportParams: UpdatedSchedulesReportParam): Observable<Blob> {
        return withSpinner(this.http).post(`${this.reportBaseUrl}/downloadupdatedschedulesreport`, updatedSchedulesReportParams, { responseType: "blob" });
    }

    emailConstructionDeliveryReport(constructionDeliveryReportParams: ConstructionDeliveryReportParams): Observable<any> {
        return withSpinner(this.http).post(`${this.reportBaseUrl}/constructiondeliveryreport`, constructionDeliveryReportParams);
    }

    emailSchedulesAndOptionsReport(tradePartners: Vendor[], lots: Lot[], reportTypes: string[], taskStatus: string, includeInternalTasks: boolean, includeScarTasks: boolean, format: string): Observable<any> {
        return this.http.post<any>(`${this.reportBaseUrl}/schedulesAndOptions`, { "tradePartners": tradePartners, "lots": lots, "reportTypes": reportTypes, "taskStatus": taskStatus, "includeInternalTasks": includeInternalTasks, "includeScarTasks": includeScarTasks, "format": format });
    }

    emailSchedulePermitsReport(communityIds: number[], lotStatus: string, format: string): Observable<any> {
        return withSpinner(this.http).post(`${this.reportBaseUrl}/emailpermitsreport`, {
            "communityIds": communityIds, "lotStatus": lotStatus, "format": format
        }, { responseType: "blob" });
    }

    emailOverdueTaskDetailReport(reportParameters: OverdueTaskDetailReportParameters): Observable<Blob>{
        return withSpinner(this.http).post<any>(`${this.reportBaseUrl}/emailoverduetaskdetailreport`, reportParameters);
    }

    emailWeeklyReport(weeklyReportParams: WeeklyReportParams): Observable<Blob> {        
        return withSpinner(this.http).post<any>(`${this.reportBaseUrl}/emailweeklyreport`, weeklyReportParams);
    }

    emailUpdatedSchedulesReport(updatedSchedulesReportParams: UpdatedSchedulesReportParam): Observable<Blob> {
        return withSpinner(this.http).post<any>(`${this.reportBaseUrl}/emailupdatedschedulesreport`, updatedSchedulesReportParams);
    }
}
